import { render, staticRenderFns } from "./faka-detail.vue?vue&type=template&id=1a25cdd8&scoped=true"
import script from "./faka-detail.vue?vue&type=script&lang=js"
export * from "./faka-detail.vue?vue&type=script&lang=js"
import style0 from "./faka-detail.vue?vue&type=style&index=0&id=1a25cdd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a25cdd8",
  null
  
)

export default component.exports